import UtilsService from "app/services/utils/utils.service";
// requiring html templates so that hot reloading works
const template = require('./linkTextArea.html');

const NS = 'LinkTextArea'; // jshint ignore:line

export default function LinkTextArea() { // as linkTextArea
    "ngInject";

    return {
        restrict: 'E',
        replace: true,
        link,
        controller,
        controllerAs: 'vm',
        template,
        bindToController: true,
        scope: {
            text: '=',
        }
    };

    function link(scope, element) {
        scope.vm.input = element[0].children[0];
    }

    function controller($scope, $timeout, unregister) {
        "ngInject";

        var vm = this;
        // properties
        vm.editing = false;
        vm.linkText = '';
        // methods
        vm.startEdit = startEdit;
        vm.endEdit = endEdit;
        // -- listeners
        var listeners = [];
        listeners.push($scope.$watch('vm.text', parseText));
        listeners.push($scope.$on('$destroy', () => unregister(listeners)));

        parseText();

        function startEdit(dontFocus) {
            vm.editing = true;
            if (!dontFocus) {
                $timeout(function() {
                    vm.input.focus();
                }, 50);
            }
        }

        function endEdit() {
            vm.editing = false;
        }

        function parseText() {
            vm.linkText = UtilsService.addLinksToText(vm.text);
        }
    }
}
